import {
    Box,
    Button,
    Text,
    Tooltip,
    useBoolean,
    useOutsideClick
} from '@chakra-ui/react'
import { FileItem } from 'pages/Report/types'
import { useRef } from 'react'

interface FileGeneratorProps {
    callAPI: (file: FileItem) => void
    loading: boolean
}

export const FileGeneratorMultiPDF = ({
    callAPI,
    loading
}: FileGeneratorProps) => {
    const refTooltip = useRef(null)
    const [tooltipState, setTooltipState] = useBoolean(false)

    useOutsideClick({
        ref: refTooltip,
        handler: setTooltipState.off
    })

    const files: Array<FileItem> = [
        {
            type: 'CSV'
        },
        {
            type: 'EXCEL'
        },
        {
            type: 'EXCEL',
            faturaText: 'BB',
            newLayout: true
        },        
        {
            type: 'PDF',
            faturaText: 'Serviços',
            faturaValue: 'SERVICO'
        },
        {
            type: 'PDF',
            faturaText: 'Taxas',
            faturaValue: 'TAXA'
        }
    ]

    const downloadCsv = (file: FileItem) => {
        callAPI(file)
        setTooltipState.off()
    }

    const onGenerateFile = () => {
        setTooltipState.on()
    }

    return (
        <>
            <Tooltip
                ref={refTooltip}
                isOpen={tooltipState}
                hasArrow
                placement="bottom-start"
                backgroundColor="none"
                label={
                    <Box
                        bg="white"
                        width="150px"
                        borderRadius="8px"
                        pointerEvents="auto"
                        textAlign="center"
                        paddingY="12px"
                    >
                        <Text
                            fontSize="14px"
                            fontWeight={'bold'}
                            padding="16px 10px"
                            color="black"
                        >
                            Selecionar tipo:
                        </Text>

                        {files.map((file, index) => {
                            return (
                                <Button
                                    key={index}
                                    width="100%"
                                    height="32px"
                                    colorScheme="off-white"
                                    color="black"
                                    onClick={() => downloadCsv(file)}
                                    _hover={{
                                        background: 'grayscale.50'
                                    }}
                                >
                                    {file.type}{' '}
                                    {file.faturaText
                                        ? `${file.faturaText}`
                                        : ''}
                                </Button>
                            )
                        })}
                    </Box>
                }
            >
                <Button
                    colorScheme="primary"
                    onClick={onGenerateFile}
                    isLoading={loading}
                >
                    Gerar relatório
                </Button>
            </Tooltip>
        </>
    )
}
